// extracted by mini-css-extract-plugin
export var container = "_5d-0";
export var disabled = "_5d-4";
export var fullWidth = "_5d-3";
export var lined = "_5d-1";
export var selected = "_5d-5";
export var tab = "_5d-2";